export const formatCpf = (cpf) => {
  if (cpf.length !== 11) {
    return ''
  }
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}